
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-rss",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-rss"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 11a9 9 0 019 9M4 4a16 16 0 0116 16"}}),_c('circle',{attrs:{"cx":"5","cy":"19","r":"1"}})])
          )
        }
      }
    